import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconSurfboardBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M0 0h2.477v19.12H0z" />
				<path id="c" d="M0 0h16.51v19.758H0z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<g transform="translate(13.736 2.138)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#E42822"
						d="M1.239 7.576.814 6.518h.85zm1.213-1.26.002-.004c.007-.018.006-.036.01-.054.005-.023.013-.044.013-.069v-.003c0-.03-.01-.06-.019-.09q-.003-.018-.007-.035c-.005-.012-.015-.02-.021-.032-.015-.025-.029-.051-.05-.072-.006-.007-.017-.01-.025-.017a.3.3 0 0 0-.08-.053q-.003-.001-.003-.002c-.02-.008-.041-.007-.062-.011s-.04-.013-.06-.013h-.593V.328a.328.328 0 1 0-.656 0v5.533H.328c-.022 0-.042.009-.064.013-.02.004-.039.003-.058.011l-.002.001a.3.3 0 0 0-.086.057q-.01.006-.021.014-.031.033-.05.075c-.006.01-.016.018-.02.029-.005.01-.004.023-.008.034a.3.3 0 0 0-.018.091L0 6.19c0 .024.009.046.014.068.004.019.003.037.01.055l.002.004v.002l.875 2.176V18.79a.328.328 0 1 0 .656 0V8.544l.894-2.226z"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(3.8 2.138)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#000"
						d="M11.156.682c.621.532 2.329 5.234 2.329 10.511 0 4.421-1.009 6.96-1.399 7.774l-.709-.43a.3.3 0 0 0-.151-.066q-.03-.003-.057-.002-.028-.001-.055.002a.3.3 0 0 0-.152.066l-.71.43c-.39-.81-1.398-3.336-1.398-7.774 0-5.46 1.689-10.057 2.302-10.51m5.026 13.509H13.98c.1-.885.161-1.882.161-2.999a28.7 28.7 0 0 0-1.068-7.633C12.707 2.272 11.991.146 11.238.013 11.217.008 11.198 0 11.175 0h-.01q-.013.002-.024.005C9.812.106 8.198 6.214 8.198 11.193c0 1.14.065 2.156.168 3.054h-.97a.3.3 0 0 0-.104.022 3.3 3.3 0 0 1-3.275-3.296 3.3 3.3 0 0 1 3.297-3.296.33.33 0 0 0 .328-.329v-.004a.33.33 0 0 0-.328-.328H5.81c-.014 0-.027.006-.041.008a5.92 5.92 0 0 0-5.535 7.562.329.329 0 0 0 .63-.183 5.3 5.3 0 0 1-.208-1.47c0-2.594 1.892-4.75 4.367-5.175a3.95 3.95 0 0 0-1.662 3.215 3.957 3.957 0 0 0 3.953 3.953.3.3 0 0 0 .11-.022H8.45c.448 3.117 1.344 4.615 1.394 4.697q.013.02.03.036.011.017.024.03.017.015.036.027.014.013.032.023.023.012.048.02.014.006.028.01a.34.34 0 0 0 .169-.001c.009-.002.016-.008.024-.01q.03-.01.059-.026h.001l.875-.532.874.531h.001q.03.018.059.026.012.006.024.01a.33.33 0 0 0 .17.002q.013-.004.027-.01.025-.009.049-.02.015-.01.031-.023.019-.012.036-.026.013-.015.025-.03.015-.018.03-.037c.05-.083.956-1.598 1.402-4.753h2.284a.328.328 0 1 0 0-.656"
						mask="url(#d)"
					/>
				</g>
			</g>
		</svg>
	);
}
